var $03c9a1a10de12f06$exports = {};
$03c9a1a10de12f06$exports = {
    "Clear search": `\u{645}\u{633}\u{62D} \u{627}\u{644}\u{628}\u{62D}\u{62B}`
};


export {$03c9a1a10de12f06$exports as default};
//# sourceMappingURL=ar-AE.module.js.map
